module.exports = __webpack_public_path__ + "img/mcb-yn1.343f7c21.gif";